// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"3a01c1d7","264":"f5bbf097","418":"ba0fc976","480":"9d5bfbba","638":"bc287f79"}[chunkId] + ".chunk.js";
};